<template>
  <div class="CartProducts4">
    <div class="cart-products">
      <section id="servicios" class=" secciones seccion-gris">
        <div id="etapas-compra">
          <div class="etapas-compra-hitos">
            <router-link :to="'/carrito'" class="hito-inactivo"
              >Carro de compras</router-link
            >
            <router-link :to="'/datos-compra'" class="hito-inactivo"
              >Datos para la compra</router-link
            >
            <router-link :to="'/resumen'" class="hito-activo"
              >Finalizar Compra</router-link
            >
          </div>
        </div>

        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-sm-12">
              <cart-calculator ref="cartCalculator"></cart-calculator>
            </div>
          </div>
        </div>
      </section>
      <TwoModules></TwoModules>
      <News></News>
    </div>
  </div>
</template>

<script>
import TwoModules from '@/components/products/TwoModules.vue';
import News from '@/components/products/Guia.vue';
import { config_settings } from '../../../../config.js';
import { mapState, mapActions, mapMutations } from 'vuex';
import CartCalculator from '../CartFinishVisa/CartFinishVisa';

//HTTP ERROR STATUS
const NOT_FOUND = 404;
const BAD_REQUEST = 400;
const UNAUTHORIZED = 401;
const INTERNAL_SERVER_ERROR = 500;

export default {
  name: 'CartProducts',
  components: { CartCalculator, TwoModules, News },
  data() {
    return {
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
    };
  },
  computed: mapState(['cartProducts']),
  methods: {
    /* Resetting the store and localstorage after removing product from cart */
    ...mapMutations(['SET_CART_PRODUCTS']),

    removeProductCart(product) {
      var products = JSON.parse(localStorage.getItem('iki-cart'));
      for (let i = 0; i < products.length; i++) {
        if (products[i].code_product === product.code_product) {
          products.splice(i, 1);
        }
      }
      this.SET_CART_PRODUCTS(products);
      localStorage.setItem('iki-cart', JSON.stringify(products));
      this.$refs.cartCalculator.analizeCart();
    },
    navigateProductDetail(product) {
      this.$router.push({
        name: 'detalle-productos',
        params: { id: product.code_product },
      });
    },
    scroll_inicio() {
      window.scrollTo(0, 0);
    },
  },

  created() {
    this.scroll_inicio();
  },
};
</script>

<style lang="scss" src="./CartProducts-4.scss"></style>
